<template>
	<div class="margin-left-sm">
		<div class="flex">
			<!-- 登录信息 -->
			<div class="bg-white padding-sm myinfo flex flex-direction justify-between" v-if="userInfo">
				<div class="flex align-center">
					<img class="block-74 margin-right-xs" :src="userInfo.avatar">
					<div>
						<div class="flex align-center">
							<p class="name">{{userInfo.nick_name}}</p>
							<p class="identity text-xs text-theme">{{userInfotype | filterType}}</p>
						</div>
						<p class="name text-left margin-top-xs text-999">{{userInfo.miPhone}}</p>
					</div>
				</div>
				<div class="flex align-center justify-between">
					<p class="perfect pointer text-theme text-center" @click="fect('resume')">完善简历</p>
					<p class="pointer" @click="fect('setinfo')">
						<i class="el-icon-setting"></i>
						<span>设置</span>
					</p>
				</div>
			</div>
			<!-- 登录信息 end -->
			<!-- 未登录 -->
			<div class="bg-white padding-sm myinfo flex flex-direction justify-between" v-else>
				<div class="flex align-center" @click="gologin">
					<img class="block-74 margin-right-xs" src="../../assets/logo.png">
					<div>
						<div class="flex align-center">
							<p class="name">登录</p>
						</div>
					</div>
				</div>
			</div>
			<!-- 未登录 end -->
			<!-- 统计 start -->
			<div class="census bg-white flex flex-direction margin-left-sm">
				<div class="flex height100">
					<div class="flex-sub text-center flex flex-direction justify-center census-item pointer"
						@click="fect('integral')">
						<p class="num text-333 text-bold">{{userInfo?integral:0}}</p>
						<p class=" text-xs text-999">我的积分</p>
					</div>
					<div class="flex-sub text-center flex flex-direction justify-center census-item pointer"
						@click="fect('collect')">
						<p class="num text-333 text-bold">{{userInfo?coll:0}}</p>
						<p class=" text-xs text-999">我的收藏</p>
					</div>
					<div class="flex-sub text-center flex flex-direction justify-center census-item pointer"
						@click="fect('seenrecruit')">
						<p class="num text-333 text-bold">{{userInfo?seeWork:0}}</p>
						<p class=" text-xs text-999">谁看过我的招工</p>
					</div>
					<div class="flex-sub text-center flex flex-direction justify-center pointer"
						@click="fect('seenwork')">
						<p class="num text-333 text-bold">{{userInfo?seeUserinfo:0}}</p>
						<p class=" text-xs text-999">谁看过我的找活</p>
					</div>
				</div>
				<p class="flex align-center recharge">
					<img src="../../assets/img/fill.png">
					<span class="text-xs text-prices margin-left-xs">充值</span>
				</p>
				<div class="flex justify-between align-center realname">
					<div class="flex align-center">
						<img src="../../assets/img/pre_icon.png">
						<p class="text-theme text-xs margin-left-xs">完成实名认证，信息优先推荐！</p>
					</div>
					<div class="flex align-center pointer" @click="fect('idcard')">
						<img src="../../assets/img/you_icon.png">
						<p class="text-theme text-xs text-bold margin-left-xs">去实名</p>
					</div>
				</div>
			</div>
			<!-- 统计 end -->
		</div>
		<!-- 推荐功能 -->
		<div class="bg-white fu-order-box margin-top height225">
			<p class="name text-left solid-bottom padding-top padding-bottom-sm padding-left">推荐功能</p>
			<div class="flex padding-tb-sm">
				<div class="flex-sub text-center" @click="fect('share')">
					<img class="invit" src="https://manage.ciiply.com/web/static/my/005.png">
					<p class="text-666 text-sm margin-top-xs">邀请好友</p>
				</div>
				<div class="flex-sub text-center" @click="fect('recruit')">
					<img class="myzhao" src="https://manage.ciiply.com/web/static/my/007.png">
					<p class="text-666 text-sm margin-top-xs">我的招工</p>
				</div>
				<div class="flex-sub text-center" @click="fect('resume')">
					<img class="myhuo" src="https://manage.ciiply.com/web/static/my/008.png">
					<p class="text-666 text-sm margin-top-xs">我的找活</p>
				</div>
				<div class="flex-sub text-center" @click="fect('task')">
					<img class="mytask" src="https://manage.ciiply.com/web/static/my/009.png">
					<p class="text-666 text-sm margin-top-xs">任务中心</p>
				</div>
				<div class="flex-sub text-center" @click="fect('frequency')">
					<img class="shipin" src="https://manage.ciiply.com/web/static/my/006.png">
					<p class="text-666 text-sm margin-top-xs">面试视频</p>
				</div>
				<div class="flex-sub text-center" @click="fect('wallet')">
					<img class="mytask" src="https://manage.ciiply.com/web/static/my/011.png">
					<p class="text-666 text-sm margin-top-xs">我的钱包</p>
				</div>
				<div class="flex-sub text-center" @click="fect('withdraw')">
					<img class="mytask" src="https://manage.ciiply.com/web/static/my/012.png">
					<p class="text-666 text-sm margin-top-xs">申请提现</p>
				</div>
			</div>
		</div>
		<!-- 推荐功能 end -->
		<div class="flex margin-top">
			<!-- 课程订单 -->
			<div class="bg-white fu-order-box flex-sub margin-right-sm ">
				<p class="name text-left solid-bottom padding-top padding-bottom-sm padding-left">课程订单</p>
				<div class="flex padding-tb-sm">
					<div class="flex-sub text-center" @click="fect('couorder')">
						<img class="all" src="https://manage.ciiply.com/web/static/my/all.png">
						<p class="text-666 text-sm margin-top-xs">全部订单</p>
					</div>
					<div class="flex-sub text-center">
						<img class="unpay" src="https://manage.ciiply.com/web/static/my/unpay.png">
						<p class="text-666 text-sm margin-top-xs">待付款</p>
					</div>
					<div class="flex-sub text-center">
						<img class="pay" src="https://manage.ciiply.com/web/static/my/pay.png">
						<p class="text-666 text-sm margin-top-xs">已付款</p>
					</div>
					<div class="flex-sub text-center" @click="fect('purlist')">
						<img class="purchased" src="https://manage.ciiply.com/web/static/my/purchased.png">
						<p class="text-666 text-sm margin-top-xs">已购课程</p>
					</div>
				</div>
			</div>
			<!-- 课程管理 -->
			<div class="bg-white fu-order-box flex-sub">
				<p class="name text-left solid-bottom padding-top padding-bottom-sm padding-left">课程管理</p>
				<div class="flex padding-tb-sm">
					<div class="flex-sub text-center" @click="fect('curlease')">
						<img class="ckfabu" src="https://manage.ciiply.com/web/static/my/001.png">
						<p class="text-666 text-sm margin-top-xs">发布课程</p>
					</div>
					<div class="flex-sub text-center" @click="fect('mine')">
						<img class="mykc" src="https://manage.ciiply.com/web/static/my/002.png">
						<p class="text-666 text-sm margin-top-xs">我的课程</p>
					</div>
					<div class="flex-sub text-center" @click="fect('examine')">
						<img class="kcshen" src="https://manage.ciiply.com/web/static/my/003.png">
						<p class="text-666 text-sm margin-top-xs">课程审核</p>
					</div>
					<div class="flex-sub text-center" @click="fect('sale')">
						<img class="xiaoshou" src="https://manage.ciiply.com/web/static/my/004.png">
						<p class="text-666 text-sm margin-top-xs">销售订单</p>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Bus from '@/store/eventBus.js'
	export default {
		data() {
			return {
				integral: 0, //我的积分
				coll: 0, //我的收藏
				seeWork: 0, //谁看过我的招工
				seeUserinfo: 0, //谁看过我的找活
				is_subscribe: 0, //是否实名认证
				is_real_company: 0, //是否企业认证
				userInfotype:0
			}
		},
		computed: {
			// 是否登录状态
			isLogin() {
				return this.$store.getters.isLogin;
			},
			userInfo() {
				if (this.$store.getters.userInfo) {
					return this.$store.getters.userInfo;
				} else {
					return JSON.parse(localStorage.getItem('USER_INFO'));
				}
			}
		},
		created() {
			this.getinfo()
			this.getcensus()
			this.getren(1)
			this.getren(2)
			console.log(this.userInfo);
		},
		methods: {
			/**
			 * 跳转对应组件
			 * type string 对应组件名
			 * */
			fect(type) {
				let typeq = {
					type: type,
					typeone: ''
				}
				this.$emit('gettype', typeq)
			},
			/**
			 * 显示登录弹窗
			 * */
			gologin(){
				Bus.$emit('showlogon')
			},
			getinfo(){
				this.ajax('get', '/api/userInfo/myUserInfo', { }, res => {
					console.log(res);
					if (res.status == 200) {
						this.userInfotype = res.data.userInfo.type
						// this.age = res.data.user.age
						// this.nation = res.data.user.nation
						// this.nick_name = res.data.user.nick_name
						// // this.sexName = res.data.user.sex
						// let sexIndex = res.data.user.sex
						// this.sexName = this.sex[sexIndex].name;
						// this.phone = res.data.user.phone
						// this.avatar = res.data.user.avatar
						
					} else {
						
					}
				})
			},
			/**
			 * 获取实名认证和企业认证状态
			 * type  1  实名   2  企业
			 * */
			getren(type) {
				this.ajax('get', '/api/pc/userReal/getReal', {
					type: type
				}, res => {
					console.log(res);
					if (res.status == 200) {
						switch (type) {
							case 1:
								this.is_subscribe = res.data.is_real
								this.idcard = res.data.idcard ? res.data.idcard : 0
								break;
							case 2:
								this.is_real_company = res.data.is_real
								break;
							case 3:

								break;
						}
					} else {

					}
				})
			},
			/**
			 * 统计接口
			 * */
			getcensus() {
				this.ajax('get', '/api/pc/user/census', {}, res => {
					console.log(res);
					if (res.status == 200) {
						this.integral = res.data.integral
						this.coll = res.data.coll
						this.seeWork = res.data.seeWork
						this.seeUserinfo = res.data.seeUserinfo
					} else {

					}
				})
			},
		},
		filters: {
			filterType(val) {
				switch (val) {
					case 0:
						return '个人';
					case 1:
						return '班组';
					case 2:
						return '施工队';
			 	case 3:
						return '突击队';

					default:
						return '';
				}
			}
		}
	}
</script>

<style scoped lang="less">
	.block-74 {
		width: 74px;
		height: 74px;
		border-radius: 50%;
	}

	.name {
		font-size: 22px;
	}

	.identity {
		width: 54px;
		height: 22px;
		line-height: 22px;
		background: rgba(11, 131, 124, 0.1);
		border-radius: 6px;
	}

	.perfect {
		width: 98px;
		height: 34px;
		line-height: 34px;
		border: 1px solid #0B837C;
		border-radius: 17px;
	}

	.myinfo {
		width: 303px;
		height: 188px;
		box-shadow: -4px 3px 19px 1px rgba(204, 204, 204, 0.2000);
		border-radius: 20px;
	}

	.height225 {
		height: 225px;
	}

	.census {
		width: 597px;
		height: 188px;
		box-shadow: -4px 3px 19px 1px rgba(204, 204, 204, 0.2000);
		border-radius: 20px;
		padding-top: 6px;

		.height100 {
			height: 100px;
		}

		.census-item {
			position: relative;

			&:after {
				position: absolute;
				width: 1px;
				height: 15px;
				background: #ccc;
				content: '';
				right: 0;
				top: 50%;
				transform: translateY(-50%);
			}
		}

		.num {
			font-size: 26px;
		}

		.recharge {
			margin-left: 50px;
			margin-bottom: 20px;
		}

		.realname {
			height: 43px;
			background: rgba(11, 131, 124, 0.1000);
			box-shadow: 0px 4px 19px 0px rgba(208, 208, 208, 0.0500);
			border-radius: 0px 0px 20px 20px;
			padding: 10px 21px;
		}
	}

	.fu-order-box {
		box-shadow: 0px 4px 19px 0px rgba(208, 208, 208, 0.0500);
		border-radius: 20px;
	}

	.all {
		width: 38px;
		height: 46px;
	}

	.unpay {
		width: 44px;
		height: 46px;
	}

	.pay {
		width: 49px;
		height: 46px;
	}

	.purchased {
		width: 44px;
		height: 46px;
	}

	.ckfabu {
		width: 43px;
		height: 46px;
	}

	.mykc {
		width: 42px;
		height: 46px;
	}

	.kcshen {
		width: 44px;
		height: 46px;
	}

	.xiaoshou {
		width: 49px;
		height: 46px;
	}

	.invit {
		width: 47px;
		height: 46px;
	}

	.myzhao {
		width: 38px;
		height: 46px;
	}

	.myhuo {
		width: 45px;
		height: 46px;
	}

	.shipin {
		width: 55px;
		height: 46px;
	}

	.mytask {
		width: 46px;
		height: 46px;
	}
</style>



// WEBPACK FOOTER //
// src/view/my/myself.vue